import * as types from '@/store/types'

export default {
    loadMailingGroups: (context, payload) => {
        context.mailingGroups = payload
        context.mailingGroupsLoaded = true
    },
    changeCountMailingGroup: (context, payload) => {
        const index = context.mailingGroups.findIndex(item => item.id === +payload.id)
        if (context.mailingGroups[index] !== undefined) {
            if (payload.subscribe === 1) {
                context.mailingGroups[index].count += payload.count
            } else {
                if (context.mailingGroups[index].count - payload.count >= 0) {
                    context.mailingGroups[index].count -= payload.count
                } else {
                    context.mailingGroups[index].count = 0
                }
            }
        }
    }
}
